// Configuration centralisée de toutes les images du site
// Ce fichier contient les URLs par défaut de toutes les images
import footerLogo from "../assets/images/logo/Logo_Carpe_Diem.png";
import { safeJsonParse } from "../utils/safeJson";

const LEGACY_FOOTER_LOGO_URL = "https://i.ibb.co/your-logo-url/logo.png";

const defaultImagesConfig = {
  // Images du header pour chaque page
  header: {
    home: "https://i.ibb.co/bgwCkjFv/resto-vinc.jpg",
    homeAlt: "Restaurant Carpe Diem - Page d'accueil",
    menu: "https://i.ibb.co/4Zm9VF9k/menu.jpg",
    menuAlt: "Menu du restaurant Carpe Diem",
    restaurantChambres: "https://i.ibb.co/9Hwtx1Vs/Salle-manger-de-jour.jpg",
    restaurantChambresAlt: "Restaurant et chambres d'hôtes Carpe Diem",
    reservation: "https://i.ibb.co/jZk6brPV/resto.jpg",
    reservationAlt: "Réservation Carpe Diem",
    contact: "https://i.ibb.co/tTk44PJB/contact.png",
    contactAlt: "Contact Carpe Diem",
  },

  // Images de la page Home
  home: {
    heroImage1: "https://i.ibb.co/2YH84nZ1/bardeco.jpg",
    heroImage1Alt: "Bar décoration Carpe Diem",
    menuSectionBg: "https://i.ibb.co/N6GG61zP/plat.jpg",
    menuSectionBgAlt: "Section Menu - Plats du restaurant",
  },

  // Images de la page Team/Restaurant
  team: {
    restaurantMain: "https://i.ibb.co/Wvsywqjc/resto-jour-devanture.jpg",
    restaurantMainAlt: "Restaurant Carpe Diem - Vue principale",
    chambreMain: "https://i.ibb.co/HfGJLP06/resto-nuit.jpg",
    chambreMainAlt: "Chambres d'hôtes Carpe Diem",
  },

  // Images de la page Contact
  contact: {
    mapScreenshot: "/assets/images/maps.png",
    mapScreenshotAlt: "Carte - Localisation Carpe Diem",
  },

  // Logo footer
  footer: {
    logo: footerLogo,
    logoAlt: "Logo Carpe Diem",
  },
};

// Clé de stockage dans localStorage
const STORAGE_KEY = "carpeDiemImagesConfig";

// Récupérer la configuration des images (depuis localStorage ou par défaut)
export function getImagesConfig() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = safeJsonParse(stored, null);

      if (parsed?.footer?.logo === LEGACY_FOOTER_LOGO_URL) {
        return {
          ...parsed,
          footer: {
            ...parsed.footer,
            logo: footerLogo,
          },
        };
      }

      return parsed;
    }
  } catch (error) {
    console.error("Erreur lors de la lecture des images:", error);
  }
  return defaultImagesConfig;
}

// Sauvegarder la configuration dans localStorage
export function saveImagesConfig(config) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
  } catch (error) {
    console.error("Erreur lors de la sauvegarde des images:", error);
  }
}

// Récupérer une image spécifique par son chemin (ex: "header.home")
export function getImage(path) {
  const config = getImagesConfig();
  const parts = path.split(".");

  let value = config;
  for (const part of parts) {
    if (value && typeof value === "object") {
      value = value[part];
    } else {
      return null;
    }
  }

  return value || null;
}

// Mettre à jour une image spécifique
export function updateImage(path, newValue) {
  const config = getImagesConfig();
  const parts = path.split(".");

  let target = config;
  for (let i = 0; i < parts.length - 1; i++) {
    if (!target[parts[i]]) {
      target[parts[i]] = {};
    }
    target = target[parts[i]];
  }

  target[parts[parts.length - 1]] = newValue;
  saveImagesConfig(config);
}
